import React from 'react';

import ElementFieldRecordReference from '..';

import { ITableConfig, TableModeType } from '../../../../../types/space';
import FieldLookup from '../../FieldLookup';

interface IProps {
  recordId: string;
  fieldId: string;
  config: ITableConfig;
  isLookup: boolean;
  depth?: number;
  spaceId: string;
}

/**
 * If this is from a lookup, it has to be a lookup within the table.
 */
const RefRenderer: React.FC<IProps> = ({ config, recordId, fieldId, isLookup, depth, spaceId }) =>
  isLookup ? (
    <FieldLookup
      recordId={recordId}
      fieldId={fieldId}
      config={config}
      isInTable={isLookup}
      depth={depth}
      spaceId={spaceId}
    />
  ) : config.tableMode === TableModeType.Table ? (
    <ElementFieldRecordReference.TableWithFieldId
      recordId={recordId}
      fieldId={fieldId}
      config={config}
      depth={depth}
      spaceId={spaceId}
    />
  ) : (
    <ElementFieldRecordReference.ListWithFieldId
      recordId={recordId}
      fieldId={fieldId}
      config={config}
      depth={depth}
      spaceId={spaceId}
    />
  );

export default RefRenderer;
